export const zIndices = {
  navigation: 1250,
};
